import URI from 'urijs'
import { fork, call, put, take, cancel, select } from 'redux-saga/effects'
import { delay } from 'redux-saga'

import { exportSagas } from '../sharedLegacy/utils/sagas'

import { actionNames } from './actions'
import { getLiveData } from './api'

let pollLiveDataInterval = 2000

const getLiveId = (state) => state.webinarAudienceRoom.liveId
const getLiveToken = (state) => state.webinarAudienceRoom.liveToken
const getPrevBroadcastingState = (state) =>
  state.webinarAudienceRoom.hasBeenBroadcasting

function* fetchLiveDataWorker(action) {
  const cacheBusting = { ___: '....' }
  const uri = URI(window.location.search)

  try {
    const liveData = yield call(getLiveData, action.liveId, action.liveToken, {
      include_webinar_images_p: 1,
      ...(uri.hasQuery('___', '....') && cacheBusting),
    })

    yield put({ type: actionNames.FETCH_LIVE_DATA_SUCCESS, data: liveData })
  } catch (err) {
    yield put({ type: actionNames.LIVE_EVENT_NOT_FOUND, error: err.message })
  }
}

function* pollLiveDataWorker() {
  const liveId = yield select(getLiveId)
  const liveToken = yield select(getLiveToken)

  while (true) {
    try {
      const liveData = yield call(getLiveData, liveId, liveToken)
      const isBroadcasting = liveData.broadcasting_p === 1

      if (isBroadcasting) {
        pollLiveDataInterval = 5000
      } else {
        pollLiveDataInterval = 2000
      }

      yield put({
        type: actionNames.LIVE_STATUS_POLL_SUCCESS,
        isBroadcasting,
        liveStatus: liveData.live_status,
      })

      const hasBeenBroadcasting = yield select(getPrevBroadcastingState)

      if (
        !isBroadcasting &&
        liveData.live_status === 'previous' &&
        hasBeenBroadcasting
      ) {
        if (liveData.after_webinar_link) {
          window.location.href = liveData.after_webinar_link
        }

        yield put({ type: actionNames.WEBINAR_ENDED })
      }
    } catch (err) {
      // not a critical failure
    }

    yield delay(pollLiveDataInterval)
  }
}

function* pollLiveData() {
  yield take(actionNames.FETCH_LIVE_DATA_SUCCESS)

  const fetchWebinarInfoLoop = yield fork(pollLiveDataWorker)

  yield take(actionNames.WEBINAR_ENDED)
  yield cancel(fetchWebinarInfoLoop)
}

function* init(action) {
  yield fork(pollLiveData)
  yield fork(fetchLiveDataWorker, action)
}

export default exportSagas(
  [init],
  actionNames.INIT_AUDIENCE_ROOM,
  actionNames.LEAVE_AUDIENCE_ROOM
)
